<template>

		<b-table :items="items"></b-table>

</template>


<script>
  import haul_service from './haul_service'


  const items = []
  export default {
    name: 'hauls',
    created: function() {
      this.getAll()
    },
    data() {
      return {

        items: items,
      }
    },
    methods: {
      getAll() {
        haul_service.test()
          .then(data => {
							this.items = data.hauls
					})
      },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/hauls/tests.vue